import React from 'react';
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { Label } from './styled/Field';
const FieldsetLabel = styled(Label)`
  margin-bottom: 0;
`;
const Fieldset = styled.fieldset`
  margin-top: ${gridSize}px;
`;
export default (({
  children,
  legend
}) => /*#__PURE__*/React.createElement(Fieldset, null, legend && /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(FieldsetLabel, null, legend)), children));